<script setup lang="ts">
import type { AxiosError } from 'axios'
import { ROUTES } from '@configs'

const route = useRoute()
const { t } = useI18n()
const postStore = usePostStore()
const { post } = storeToRefs(postStore)
const err = ref<AxiosError>()

const { data: _post } = await useAsyncData(
  `post:${route.params.id}`,
  async () => {
    try {
      const result = await postStore.fetchPost({
        cmtyNttSn: Number(route.params.id),
      })
      return Promise.resolve(result)
    } catch (_err) {
      err.value = _err as AxiosError
    }
  }
)

if (_post.value) {
  useSetSEO({
    useHeadArgs: [
      {
        title: _post.value.nttSj,
        meta: [
          {
            name: 'description',
            content: useGetMaxThreeParagraphTexts(_post.value.nttCn),
          },
        ],
      },
    ],
    useSeoMetaArgs: [
      {
        ogTitle: _post.value.nttSj,
        ogDescription: useGetMaxThreeParagraphTexts(_post.value.nttCn),
        ogImage: useGetPostThumbUrl(_post.value),
      },
    ],
  })
}

// 포스트 삭제시 뒤로가기
watch(
  () => post.value,
  async (cur) => {
    if (cur === null) {
      // 삭제 액션시 컨펌 모달이 라우트 히스토리에 남는 문제로 히스토리백 2번함
      await useNavigations({ type: 'back' })
      await useNavigations({ type: 'back' })
    }
  }
)
</script>

<template>
  <NovaBoxContentsDetailPage
    :title="t('feeds')"
    :responsive="{
      mobile: { padding: '20px 10px 60px' },
      tablet: { padding: '20px 0 60px' },
      desktop: { padding: '20px 0 60px' },
    }"
    :go-back="() => useBackParentRoute(ROUTES.FEED.path)"
  >
    <NovaContainerPostPage
      v-if="post || err"
      :cmty-ntt-sn="Number(route.params.id)"
      :post="post"
      :err="err"
    />
  </NovaBoxContentsDetailPage>
</template>

<style lang="scss" scoped></style>
